import { mutateByPath } from "../../../utility";
import { ArslActionColumnUpdate, ArsListingState } from "../interface";
import { datasetsFromColumns } from "./datasetsFromColumns";

/**
 * Updates listing header text, display pattern, or annotation result pattern for a cell edit.
 *
 * @param state - Current ARS listing state
 * @param action - Cell-update action describing the edited cell
 * @returns Updated ARS listing state, or the original state when no edit applies
 */
export const arsl_columnUpdate = <T>(
  state: ArsListingState<T>,
  action: ArslActionColumnUpdate<T>,
): ArsListingState<T> => {
  const ix = state.bodyData.arsListingColumns.findIndex((col) => col.id === action.colId);
  if (ix === -1) return state;

  const dataPath = `/bodyData/arsListingColumns/${ix}`;
  const newColumn = { ...state.bodyData.arsListingColumns[ix], ...action.column };
  const newState = mutateByPath(state, dataPath, newColumn);

  // Check new datasets
  const actionDatasets = datasetsFromColumns([newColumn]);
  const newDatasets = new Set([...state.datasets, ...actionDatasets]);
  if (newDatasets.size > state.datasets.size) {
    newState.datasets = newDatasets;
  }

  return {
    ...newState,
    changed: true,
  };
};
